import script from "./DialogUserUpdate.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogUserUpdate.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QToggle,QCardSection,QSeparator,QCardActions});
